import { CSSProperties } from "react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import useColdexTableRowMenu from "./useColdexTableRowMenu";
import { Coldex } from "../../../../../../utils/types/Coldex";
import { MoreVert, Autorenew, RemoveRedEye } from "@mui/icons-material";
import ColdexTableRowMenuConfirm from "../ColdexTableRowMenuConfirm/ColdexTableRowMenuConfirm";

export type ColdexTableRowMenuProps = {
  coldex: Coldex;
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    alignItems: "stretch",
    padding: "0 10px 0 5px",
  } as CSSProperties,
  row: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    boxSizing: "border-box",
    alignItems: "flex-start",
  } as CSSProperties,
};

export default function ColdexTableRowMenu({
  coldex,
}: ColdexTableRowMenuProps) {
  const {
    anchorEl,
    openConfirm,
    open,
    handleClick,
    handleClose,
    handleCloseConfirm,
    handleOptionUpdateDbClick,
    handleOptionRedirectReportClick,
  } = useColdexTableRowMenu();

  return (
    <div
      id={`ColdexTableRowMenuContainer-${coldex.id}`}
      className="action-content"
    >
      <Tooltip id={`ColdexTableRowMenuTooltip-${coldex.id}`} title={"Opciones"}>
        <button
          id={`ColdexTableRowMenuButton-${coldex.id}`}
          className="btn-action"
          aria-controls={
            open ? `ColdexTableRowMenuButtonMenu-${coldex.id}` : undefined
          }
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <MoreVert fontSize="medium" />
        </button>
      </Tooltip>

      <Menu
        id={`ColdexTableRowMenuButtonMenu-${coldex.id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `ColdexTableRowMenuButton-${coldex.id}`,
        }}
      >
        <div
          id={`ColdexTableRowMenuListContainer-${coldex.id}`}
          style={styles.container}
        >
          <MenuItem id={`ColdexTableRowMenuList-${coldex.id}`}>
            <div
              onClick={() => handleOptionUpdateDbClick()}
              id={`ColdexTableRowMenuItem1-${coldex.id}`}
              key={`ColdexTableRowMenuItem1-${coldex.id}`}
              style={styles.row}
            >
              <ListItemIcon id={`ColdexTableRowMenuItemIcon1-${coldex.id}`}>
                <Autorenew fontSize="small" />
              </ListItemIcon>

              <ListItemText id={`ColdexTableRowMenuItemText1-${coldex.id}`}>
                Actualizar base de datos
              </ListItemText>
            </div>
          </MenuItem>

          <MenuItem id={`ColdexTableRowMenuList-${coldex.id}`}>
            <div
              onClick={() => handleOptionRedirectReportClick(coldex?.id!)}
              id={`ColdexTableRowMenuItem2-${coldex.id}`}
              key={`ColdexTableRowMenuItem2-${coldex.id}`}
              style={styles.row}
            >
              <ListItemIcon id={`ColdexTableRowMenuItemIcon2-${coldex.id}`}>
                <RemoveRedEye fontSize="small" />
              </ListItemIcon>

              <ListItemText id={`ColdexTableRowMenuItemText2-${coldex.id}`}>
                Ver Reporte
              </ListItemText>
            </div>
          </MenuItem>
        </div>
      </Menu>

      {openConfirm && (
        <ColdexTableRowMenuConfirm close={handleCloseConfirm} coldex={coldex} />
      )}
    </div>
  );
}
